import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import { ProdutoModulo } from "../types/Produto";
import Swal from 'sweetalert2'

export default function usePostProduto(onSuccess: () => void, isLoading: () => void) {
  return useMutation((value: ProdutoModulo) => api
    .post(URLS.PRODUTOS_API, value)
    .then((response) => {
      console.log(response);
      Swal.fire({
        title: "Produto Cadastrado",
        text: "O produto foi cadastrado com sucesso!",
        icon: "success",
        position: "center",
        confirmButtonText: "OK",
        confirmButtonColor: "#349946",
        allowOutsideClick: false
      }).then(() => {
        onSuccess();
        queryClient.invalidateQueries();
      });
    })
    .catch((err : any) => {
      console.log(err);
      isLoading();
      err.response.status === 500 ?
        Swal.fire({
          title: `Erro de status ${err.response.status}`,
          text: `Ocorreu um erro interno ao cadastrar o produto. Por favor, entre em contato com um administrador do sistema.`,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false
        })
      :
        Swal.fire({
          title: "Erro ao cadastrar o produto",
          text: err.response.data.message,
          icon: "error",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#F27474",
          allowOutsideClick: false
        });
      }
    )
)
}